import { Field } from "formik";
import React from "react";

const ErrorMessage = (props) => {
  return (
    <div className="form-group form-floating">
      <Field
        type={props?.type ? props?.type : "text"}
        className={`form-control form-control-lg ${props?.errors && props?.touched && "is-invalid"}`}
        id={props.name}
        name={props.name}
      />
      <label htmlFor={props.name}>{props.label}</label>
      {props?.errors && props?.touched ? <div className="text-danger mt-1 p-1 text-small">{props?.errors}</div> : null}
    </div>
  );
};

export default ErrorMessage;
